/**
 * This is just a SSR compatible version of the document.referrer.
 * Note: You should typically use typically use useLastLocation.
 * This hook is only valuable when visitor is coming from an external source.
 * Note: You should evaluate if you should be using useFirstReferrerUrl instead.
 * The difference is that the latter will return the first non-empty referrer.
 * In contrast, this will return the last referrer, which may not be the same value.
 */
export const useReferrerUrl = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  // This is the only place we use document.referrer
  // eslint-disable-next-line no-restricted-properties
  return document.referrer ?? null;
};
